import { ProductSubType } from '../enum';
import { CourseCategoryType } from './types';

/** 코스 카테고리 페이지 헤더 (바로가기 카드는 /v1/course-finder-links, useCourseFinderLinks) */
export const COURSE_CATEGORIES: CourseCategoryType[] = [
  {
    productSubType: ProductSubType.HOMESCHOOL,
    to: '/courses/homeschool',
    pageTitle: '영어교실',
    pageDescription: '말씀으로 끝장보는 우리 아이 영어교육 솔루션!',
  },
  {
    productSubType: ProductSubType.WORSHIP,
    to: '/courses/churchschool',
    pageTitle: '주일학교 코스',
    pageDescription: '땅끝복음 준비하는 우리 교회 부흥 솔루션!',
  },
  {
    productSubType: ProductSubType.SMALL_GROUP,
    to: '/courses/smallgroup',
    pageTitle: '소그룹 코스',
    pageDescription: '전도를 위한 복음 준비부터 영어성경 일독에서 암송까지!',
  },
  // 화상영어 카테고리 페이지 헤더 - 카드 목록에서는 빠졌지만 /courses/englishconversation 페이지 제목으로 사용
  {
    productSubType: ProductSubType.LEARN_ON_PHONE,
    to: '/courses/englishconversation',
    pageTitle: '화상영어 코스',
    pageDescription: '바이블 중심 1:1 원어민 화상영어',
  },
];

/** URL 슬러그(/courses/:productSubType) → ProductSubType 매핑. 여기 없는 슬러그는 /courses로 리다이렉트 */
export const SUB_TYPE_BY_SLUG: Record<string, ProductSubType> = {
  homeschool: ProductSubType.HOMESCHOOL,
  churchschool: ProductSubType.WORSHIP,
  // 화상영어: 메뉴는 제거됐지만 라우트는 유지 (추후 화상영어 이동 버튼에서 /courses/englishconversation 사용 예정)
  englishconversation: ProductSubType.LEARN_ON_PHONE,
  smallgroup: ProductSubType.SMALL_GROUP,
};
